import React, { useEffect } from 'react';

import { AlertBannerContainer } from '../../../components';
import { ChatOverlayProvider } from '../../../context/chatOverlayContext';
import { useIspmContext } from '../../../context/ispmContext';
import { Logger } from '../../../services';
import SaviChatOverlay from '../../SaviChat/SaviChat';

import './ChatOrDashboard.css';

ChatOrDashboard.default = {
  testId: '',
};

function ChatOrDashboard() {
  Logger.info('Insight Dashboard --> ChatOrDashboard component');

  const { ispmState } = useIspmContext();

  useEffect(() => {
    // lock the body overflow to prevent scrolling
    // now that we have a better understading of the layout.
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return ispmState.isChatOverlayVisible ? (
    <ChatOverlayProvider>
      <AlertBannerContainer />
      <SaviChatOverlay />
    </ChatOverlayProvider>
  ) : (
    <div className='Ispm-ChatOrDashboard-comingSoon'>
      <h1>Ispm Dashboard Coming Soon... </h1>
    </div>
  );
}

export default ChatOrDashboard;
